export function initToolsPage() {
    const root = document.querySelector(".tools-directory-section");

    if (!root) return;

    const searchInput = document.querySelector("[data-tools-search]");
    const clearButton = document.querySelector("[data-tools-search-clear]");
    const filterButtons = Array.from(document.querySelectorAll("[data-tools-filter]"));
    const cards = Array.from(document.querySelectorAll("[data-tool-card]"));
    const sections = Array.from(document.querySelectorAll("[data-tool-section]"));
    const empty = document.querySelector("[data-tools-empty]");

    let activeFilter = "all";

    const apply = () => {
        const query = (searchInput?.value || "").trim().toLowerCase();
        let visibleCount = 0;

        cards.forEach(card => {
            const category = card.dataset.toolCategory || "";
            const isPopular = card.dataset.toolPopular === "true";
            const isNew = card.dataset.toolNew === "true";
            const search = card.dataset.toolSearch || "";

            const matchesSearch = !query || search.includes(query);

            const matchesFilter =
                activeFilter === "all" ||
                activeFilter === category ||
                (activeFilter === "popular" && isPopular) ||
                (activeFilter === "new" && isNew);

            const visible = matchesSearch && matchesFilter;

            card.hidden = !visible;
            card.classList.toggle("is-hidden", !visible);

            if (visible) {
                visibleCount++;
            }
        });

        sections.forEach(section => {
            const sectionCards = Array.from(section.querySelectorAll("[data-tool-card]"));
            const hasVisibleCard = sectionCards.some(card => !card.hidden);

            section.hidden = !hasVisibleCard;
        });

        if (empty) {
            empty.hidden = visibleCount > 0;
        }

        clearButton?.classList.toggle("is-visible", query.length > 0);
    };

    searchInput?.addEventListener("input", apply);

    clearButton?.addEventListener("click", () => {
        if (!searchInput) return;

        searchInput.value = "";
        searchInput.focus();
        apply();
    });

    filterButtons.forEach(button => {
        button.addEventListener("click", () => {
            activeFilter = button.dataset.toolsFilter || "all";

            filterButtons.forEach(x => {
                x.classList.toggle("is-active", x === button);
            });

            apply();
        });
    });

    apply();
}